<template>
  <div class="col-12 col-lg-6  weather-item-col">
    <div class="weather-item">
      <div class="weather-item__title"><span>Температура панелей</span><img src="@/assets/images/icon_panels_01.svg" width="24" alt=""></div>
      <div class="weather-temp">
        <div class="weather-temp-step__rotate">
          <div class="weather-temp-step__first">
            <div class="weather-temp-step__first_count">
              <div v-if="left !== null" class="left"><span>{{left}} °C</span></div>
              <div v-if="leftCenter !== null" class="left-center"><span>{{leftCenter}} °C</span></div>
              <div v-if="rightCenter !== null" class="right-center"><span>{{rightCenter}} °C</span></div>
              <div v-if="center !== null" class="center"><span>{{center}} °C</span></div>
              <div v-if="right !== null" class="right"><span>{{right}} °C</span></div>
            </div>
            <div class="weather-temp-step__first_line"></div>
          </div>
          <div class="weather-temp-step__second">
            <div></div>
          </div>
        </div>
        <div class="weather-temp-step__third">
          <div v-if="bottom !== null">
            <span>{{bottom}} °C</span>
          </div>
        </div>
        <div class="weather-pressure__count"><div class="weather-pressure__count_line"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import object from 'lodash/object'

export default {
  name: 'PanelTemperature',
  data () {
    return {
      id: null
    }
  },
  created () {
    this.id = this.station.meteo.term
  },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  methods: {
    minusOneHack (val) {
      if (val === -1) {
        return ''
      }

      return val
    }
  },
  computed: {
    left () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.bot === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.bot]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    },
    center () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.mid === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.mid]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    },
    right () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.top === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.top]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    },
    bottom () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.under === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.under]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    },
    leftCenter () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.bot_mid === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.bot_mid]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    },
    rightCenter () {
      if (this.$store.getters['station/lastData'] === null) {
        return null
      }
      if (this.station.meteo.temp_param.top_mid === undefined) {
        return null
      }
      const path = [this.id, this.station.meteo.temp_param.top_mid]

      return this.minusOneHack(object.get(this.$store.getters['station/lastData'], path))
    }
  }
}
</script>
